import { useQuery } from '@tanstack/react-query';
import { BaseHTTPError } from '@fe-core/errors';
import { useConfigContext } from '@fe-core';
import { getSelfregSession } from '@api/queries/selfreg';
import { TSelfregSessionDetails } from '@api/io/selfreg.io';

export const QUERY_KEY = 'selfreg-session-details';

export const useSelfregSessionDetails = ({
  enabled,
  sessionId,
}: {
  enabled: boolean;
  sessionId?: string;
}) => {
  const { config } = useConfigContext();
  if (!sessionId) {
    throw new Error('Missing sessionId');
  }

  if (!config.apiUrls.ccapi) {
    throw new Error('Missing API URL');
  }

  return useQuery<TSelfregSessionDetails, BaseHTTPError>({
    queryKey: [QUERY_KEY, sessionId],
    queryFn: async () =>
      getSelfregSession({ baseUrl: config.apiUrls.ccapi as string, sessionId }),
    retry: false,
    staleTime: 0,
    enabled: enabled,
  });
};
